// Splide init
function mmInitSplide() {
    const splideElems = document.querySelectorAll(".splide-mm-cart");
    const splideFreeProducts = document.querySelector(".splide-cart-free-products");

    splideElems.forEach((splideElem) => {
        // Check if the element exists
        if (splideElem) {
            // Vérifier si l'instance Splide est déjà attachée à cet élément
            if (splideElem.splide) {
                // Détruire l'instance Splide existante
                splideElem.splide.destroy(true);
            }

            // Initialiser une nouvelle instance de Splide et l'attacher à l'élément
            splideElem.splide = new Splide(splideElem, {
                type: "loop",
                arrows: true,
                pagination: false,
                rewind: true,
                gap: "48px",
                perPage: 3,
                destroy: true,
                breakpoints: {
                    768: {
                        destroy: false,
                        perPage: 1,
                        gap: "16px",
                        padding: {
                            right: "100px"
                        }
                    }
                }
            });

            // Monter l'instance Splide
            splideElem.splide.mount();
        }
    });
  
    // Check if the element exists
    if (splideFreeProducts) {
        // Vérifier si l'instance Splide est déjà attachée à cet élément
        if (splideFreeProducts.splide) {
            // Détruire l'instance Splide existante
            splideFreeProducts.splide.destroy(true);
        }

        // Initialiser une nouvelle instance de Splide et l'attacher à l'élément
        splideFreeProducts.splide = new Splide(splideFreeProducts, {
            type: "splide",
            arrows: true,
            pagination: false,
            rewind: true,
            gap: "16px",
            perPage: 1,
            padding: {
                right: "100px",
            }
        });

        // Monter l'instance Splide
        splideFreeProducts.splide.mount();
    }
}

document.addEventListener(
    "DOMContentLoaded",
    () => {
        mmInitSplide();
        //mmOpenCart();
    },
    { once: true }
);



function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

function mmCartSectionElement() {
    return document.getElementById("shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
    return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
    return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
    const itemEl = mmCartItem(productVariantId);

    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
    const quantityEl = mmCartItemQuantityEl(productVariantId);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(productVariantId);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmAPIRequest(method, path, body) {
    //document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
        .then((response) => response.json())
        .then((data) => {
            // mmLog(data);
            document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
            if (data.status && data.status > 400) {
                throw data;
            } else {
                return data;
            }
        });
}

// récupérer le panier
function mmGetCart() {
    return mmAPIRequest("GET", "cart.js");
}

// Ouvrir le panier
function mmOpenCart() {
    mmGetCart();
    document.querySelector(".mm-drawer-cart-wrapper").classList.add("mm-dc-is-open");
    document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-wrapper").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
    newCartEl.innerHTML = data.sections["mm-cart"];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");
    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
    mmInitSplide();
    //calculateShippingTime();
    return data;
}

// Ajouter un item au panier
function mmAddProductToCart(variantId, { quantity = 1, openCart = true }) {
    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: variantId }],
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
    .then(mmCheckForbxgyProduct)
    .then(removeOrAddFreeProducts)
    .then((data) => {
        // Mise à jour du compteur de panier
        updateCartCount();
        
        if (openCart) {
            setTimeout(mmOpenCart);
        }
    })
    .catch((error) => {
        alert("Il y a eu une erreur")
        mmOpenCart();
        console.log(error);
    });
}

function mmIncreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCartForEver(productVariantId) {
    localStorage.setItem("no_free_product_please", "true");
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroySpecificProductFromCartForEver(productVariantId) {
    localStorage.setItem(`not_this_free_product_please_${productVariantId}`, "true");
    const newQuantity = 0;
    mmSetCartItemQuantity(productVariantId, newQuantity);

    mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
    const quantity = mmGetCartItemQuantity(productVariantId);

    mmAPIRequest("POST", "cart/change.js", {
        id: productVariantId.toString(),
        quantity: quantity,
        sections: "mm-cart",
    })
    .then(refreshCartFromData)
    .then(mmCheckForbxgyProduct)
    .then(removeOrAddFreeProducts)
    .then(updateCartCount)
    .catch((error) => {
        alert("Il y a eu une erreur")
        console.log(error);
    });
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
    mmPushNewQuantity(productVariantId);
}, 300);


function updateCartCount() {
  const productCount = parseInt(document.querySelector('.mm-dc-header').dataset.cartCount);
  const countBubbles = document.querySelectorAll(".mm-cart-count-bubble");
  
  countBubbles.forEach(function(countBubble) {
    countBubble.innerText = productCount;    
  })
  
  if (productCount > 0) {
    countBubbles.forEach(function(countBubble) {
      countBubble.classList.remove('mm-none');
    })
  } else {
    countBubbles.forEach(function(countBubble) {
      countBubble.classList.add('mm-none');
    })
    localStorage.setItem("no_free_product_please", "");
  }
}

// FREE PRODUCTS
function removeOrAddFreeProducts(data) {

 const freeProductEls = document.querySelector("[data-free-products]");
  
  if (freeProductEls) { // UN SEUL PRODUIT OFFERT DANS LA LISTE
    console.log(' UN SEUL PRODUIT OFFERT DANS LA LISTE')

   let freeProductCounts = 0;

   // creates an object like { 44058675: 1, 44058001: 0 }
   // where key is free product id and value, its quantity
   const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
       console.log('freeProductEl', freeProductEl)
       const productId = freeProductEl.dataset.productId;
       const variantId = freeProductEl.dataset.variantId;
       const isFree = freeProductEl.dataset.freeProduct == "true";
       const itemEl = mmCartItem(variantId);
       console.log('isFree', isFree)
       console.log('itemEl', itemEl)
       if (isFree) {
         freeProductCounts += 1;
       }
       if (itemEl && isFree) {
         console.log('do nothing, item is already added');
       } else if (itemEl && !isFree) {
         console.log('item is present but should be removed');
         param[variantId] = 0;
       } else if (!itemEl && isFree) {
         console.log('item is absent but should be added');   
         console.log('localstorage : ', localStorage.getItem("no_free_product_please"));
         if (localStorage.getItem("no_free_product_please") == 'true') {
         } else {           
           console.log('is not true)')
           param[variantId] = 1;           
         }
       }
       return param;
   }, {});

   // Add or remove free products only if needed
   if (Object.keys(productsParams).length > 0) {
     mmAPIRequest('POST', 'cart/update.js', { updates: productsParams, sections: "mm-cart" })
       .then(refreshCartFromData)
       .then(updateCartCount)
       //.then(insertItemCountFromResponse)
       //.then(mmInitCrossSellSplide);
   }
   return data;
    
  } else { // PLUSIEURS PRODUITS OFFERTS AU CHOIX
    console.log(' PLUSIEURS PRODUITS OFFERTS AU CHOIX')
    
    const max_free_products_allowed_in_cart = parseInt(document.querySelector('.mm-drawer-cart').dataset.maxFreeProductsAllowed);
    const number_of_products_in_cart = parseInt(document.querySelector('.mm-drawer-cart').dataset.numberOfFreeProductsInCart);
    const delta = max_free_products_allowed_in_cart - number_of_products_in_cart;
  
    console.log(`On peut ajouter ${max_free_products_allowed_in_cart} produits offerts au panier`);
    console.log(`Il y a ${number_of_products_in_cart} produits offerts au panier`);
  
    if (delta == 0) {
      console.log('ne rien faire, on a ajouté le max')
    } else if (delta > 0) {
      console.log('ne rien faire, on peut encore en ajouter')
    } else if (delta < 0) {
      console.log(`Il faut retirer ${Math.abs(delta)} produits du panier`);
      removeFreeProducts(Math.abs(delta));
    }
    
    return data;
    
  }
}

// Function to remove free products in bulk
function removeFreeProducts(productsToRemove) {
  const freeProductElements = document.querySelectorAll('.mm-drawer-cart [data-free-product]');
  const updates = {}; // Objet pour stocker tous les produits à supprimer avec quantité 0

  // Remplit l'objet updates avec les produits à supprimer
  for (let i = 0; i < productsToRemove; i++) {
    if (freeProductElements[i]) {
      const variantId = freeProductElements[i].dataset.freeProductVariantId;
      updates[variantId] = 0; // Fixe la quantité à 0 pour supprimer le produit
      console.log(`Produit offert à retirer : Variant ID = ${variantId}`);
    }
  }

  // Envoie la requête pour supprimer tous les produits d'un coup avec mmAPIRequest
  mmAPIRequest("POST", "cart/update.js", {
    updates: updates,
    sections: "mm-cart"
  })
  .then(data => {
    console.log('Produits retirés du panier:', updates);
        refreshCartFromData(data);
  })
  .catch(error => {
    console.error('Erreur lors de la suppression des produits:', error);
  });
}

// Buy X get Y
function mmCheckForbxgyProduct(data) {
  const newCartEl = document.createElement("DIV");
  newCartEl.innerHTML = data.sections["mm-cart"];
  let add_this_product;
  const items_in_cart = newCartEl.querySelectorAll('[data-item-in-cart]');
  const trigger_products = newCartEl.querySelectorAll('.mm-dc-product-container[data-triggered-free-product]');

  trigger_products.forEach(function(trigger_product) {
    let free_product_id = trigger_product.dataset.triggeredFreeProduct;
    add_this_product = true;

    items_in_cart.forEach(function(item_in_cart) {
      if (item_in_cart.dataset.cartItemId == free_product_id) {
        add_this_product = false;
      }
    })

    if (add_this_product == true) {
      console.log('we add this product');
      if (localStorage.getItem(`not_this_free_product_please_${free_product_id}`) == "true") {
        console.log('1')
      } else {
        console.log('2')
        mmAddProductToCart(free_product_id, { quantity: 1, openCart: false })        
      }
    }
  })

  let remove_this_product;
  const free_products = newCartEl.querySelectorAll('[data-parent-free-products]');

  free_products.forEach(function(free_product) {
    const free_product_id = free_product.dataset.cartItemId;
    const parentFreeProducts = free_product.dataset.parentFreeProducts;
    remove_this_product = true;
    
    if (parentFreeProducts) {
        parentFreeProducts
            .split(',')
            .filter(id => id.trim() !== '') 
            .forEach(id => {
                console.log("ID de produit gratuit parent :", id);
                items_in_cart.forEach(function(item_in_cart) {
                  if (item_in_cart.dataset.productId == id) {
                    console.log('same item_in_cart.dataset.productId :', item_in_cart.dataset.productId)
                    console.log('same id :', id)
                    remove_this_product = false;
                  } else {
                    console.log('not the same item_in_cart.dataset.productId :', item_in_cart.dataset.productId)
                    console.log('not the same id :', id)
                  }
                })
            });
    };

    if (remove_this_product == true) {
      console.log('we remove the product');
      mmDestroyProductFromCart(free_product_id)
    }
  })
  
}


